import { useEffect, useState } from 'react';

import { log } from 'utils/logging';
import { getRecommendedActions } from 'utils/search/getRecommendedActions';

/*
 * Fetch recommended actions
 */
export const useRecommendedActions = (
  searchLocation: Pick<SearchLocation, 'latitude' | 'longitude'>
) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    getRecommendedActions(searchLocation, { distinct: true })
      // @ts-expect-error TS(2345): Argument of type 'Hit<TileCarouselResult>[]' is no... Remove this comment to see the full error message
      .then((hits) => setData(hits))
      .catch((e) => {
        setError(e);
        log.error(e);
      })
      .finally(() => setIsLoading(false));
  }, [searchLocation]);

  return { data, isLoading, error };
};
